import { Chevron, ExclamationCircleOutline } from '@/components/Icons'

export const FormField = ({
  label,
  id,
  name,
  type = 'text',
  value,
  onChange,
  placeholder,
  error,
  required = false,
  readOnly = false,
  options,
  rows,
  disabled = false,
  className = '',
  optional = false,
  min,
  max
}) => {
  // Determine field type
  const isSelect = type === 'select'
  const isTextarea = type === 'textarea'

  const baseInputClasses = 'col-start-1 row-start-1 text-default-900 block w-full rounded-lg bg-default-50 text-base shadow-sm outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm'

  const inputClasses = error
    ? `${baseInputClasses} px-4 py-2.5 outline-[--error] focus:outline-[--error]`
    : `${baseInputClasses} px-4 py-2.5 outline-default-200 placeholder:text-default-400 focus:outline-default-500`

  const selectClasses = error
    ? `${baseInputClasses} cursor-pointer appearance-none p-4 py-[18px] outline-[--error] focus:outline-[--error] focus:text-default-900`
    : !value
        ? `${baseInputClasses} cursor-pointer outline-default-200 appearance-none p-4 py-[18px] focus:outline-default-500 text-default-400 focus:text-default-900`
        : `${baseInputClasses} cursor-pointer outline-default-200 appearance-none p-4 py-[18px] focus:outline-default-500`

  const handleChange = (e) => {
    !disabled && !readOnly && onChange(e)
  }

  return (
    <div className={`${className}`}>
      {label && (
        <label htmlFor={id} className='block text-sm font-extrabold text-default-500 mb-2'>
          {label}{required && '*'}{optional && <span className='text-2xs font-normal relative -translate-y-0.5 ml-0.5 inline-block'> (optional)</span>}
        </label>
      )}
      <div className='grid grid-cols-1'>
        {isSelect && (
          <select
            id={id}
            name={name}
            value={value}
            onChange={handleChange}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? `${id}-error` : undefined}
            className={selectClasses}
            disabled={disabled}
          >
            <option value=''>{placeholder}</option>
            {options && options.map((option) => {
              const isObjectOption = typeof option === 'object' && option !== null
              const optionValue = isObjectOption ? option.value : option
              const optionLabel = isObjectOption ? option.label : option

              return (
                <option key={optionValue} value={optionValue}>
                  {optionLabel}
                </option>
              )
            })}
          </select>
        )}
        {isTextarea && (
          <textarea
            id={id}
            name={name}
            value={value}
            onChange={handleChange}
            rows={rows}
            placeholder={placeholder}
            className={`${inputClasses} resize-none !h-[120px] md:!h-[186px]`}
            readOnly={readOnly}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? `${id}-error` : undefined}
            disabled={disabled}
          />
        )}
        {!isSelect && !isTextarea && (
          <input
            type={type}
            id={id}
            name={name}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            readOnly={readOnly}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? `${id}-error` : undefined}
            className={inputClasses}
            disabled={disabled}
            min={min}
            max={max}
          />
        )}

        {isSelect && (
          <Chevron className='pointer-events-none box-content col-start-1 row-start-1 stroke-2 self-center justify-self-end size-6 relative -translate-x-4' />
        )}
      </div>
      {error && (
        <p id={`${id}-error`} className='text-[--error] font-extrabold text-xs mt-2'><ExclamationCircleOutline className='inline-block relative -translate-y-px' /> {error}</p>
      )}
    </div>
  )
}
